import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import styles from './ContactForm.module.scss';

// Типизируем поля нашей формы
type FormInputs = {
  name: string;
  email: string;
  phone: string;
  isAgreed: boolean;
};

export const ContactForm: React.FC = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<FormInputs>();
  const [isSubmitting, setIsSubmitting] = useState(false); // Добавим состояние загрузки

  // Функция, которая сработает только если валидация пройдена
  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    setIsSubmitting(true);

    try {
      // Замени URL на тот, что выдал тебе Firebase!
      const response = await fetch('https://sendemail-x5z3wzlebq-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert('Заявка успешно отправлена! Мы скоро свяжемся с вами.');
        reset(); // Очищаем форму
      } else {
        alert('Произошла ошибка при отправке. Попробуйте позже.');
      }
    } catch (error) {
      console.error('Ошибка:', error);
      alert('Ошибка сети. Проверьте подключение к интернету.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className={styles.formCard} onSubmit={handleSubmit(onSubmit)}>
      <h3 className={styles.formTitle}>Оставить заявку на обработку</h3>

      <div className={styles.inputRow}>
        {/* Поле Имя */}
        <div className={styles.inputWrapper}>
          <input
            type="text"
            placeholder="Имя"
            className={`${styles.input} ${errors.name ? styles.inputError : ''}`}
            {...register('name', { required: 'Обязательное поле' })}
          />
          {errors.name && <span className={styles.errorBadge}>{errors.name.message}</span>}
        </div>

        {/* Поле Email */}
        <div className={styles.inputWrapper}>
          <input
            type="email"
            placeholder="Электронная почта"
            className={`${styles.input} ${errors.email ? styles.inputError : ''}`}
            {...register('email', {
              required: 'Обязательное поле',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Неверный формат'
              }
            })}
          />
          {errors.email && <span className={styles.errorBadge}>{errors.email.message}</span>}
        </div>

        {/* Поле Телефон */}
        <div className={styles.inputWrapper}>
          <input
            type="tel"
            placeholder="+7 (000) 00-00-00"
            className={`${styles.input} ${errors.phone ? styles.inputError : ''}`}
            {...register('phone', {
              required: 'Обязательное поле',
              pattern: {
                // Регулярка для проверки базовых форматов номеров телефонов
                value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                message: 'Неверный номер'
              }
            })}
          />
          {errors.phone && <span className={styles.errorBadge}>{errors.phone.message}</span>}
        </div>
      </div>

      <div className={styles.bottomRow}>
        <div className={styles.checkboxWrapper}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              className={styles.checkbox}
              {...register('isAgreed', { required: 'Необходимо согласие' })}
            />
            <span className={styles.checkboxText}>
              Я даю согласие на <a href="/consests/processing_of_personal_data.pdf" target="_blank" rel="noreferrer" className={styles.policyLink}>обработку персональных данных</a>, а также соглашаюсь с <a href="/consests/privacy_policy.pdf" target="_blank" rel="noreferrer" className={styles.policyLink}>политикой конфиденциальности</a>
            </span>
          </label>
          {errors.isAgreed && <span className={styles.errorCheckbox}>{errors.isAgreed.message}</span>}
        </div>

        <div className={styles.submitWrapper}>
          {/* Я добавил стили для .btnPrimary, так как в твоем CSS их не было, но класс в кнопке был */}
          <button type="submit" className={styles.btnPrimary}>
            Оставить заявку
          </button>
        </div>
      </div>
    </form>
  );
};